function isAffiliate(mcsResult) {
    return mcsResult && mcsResult.lastClickSubchannel === 'Affiliates';
}

module.exports = {
    isAffiliate
};
